import { render, staticRenderFns } from "./received-detail-dialog.vue?vue&type=template&id=6cda9f79&"
import script from "./received-detail-dialog.vue?vue&type=script&lang=js&"
export * from "./received-detail-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports